import { useMemo } from 'react'
import { isToday } from '../lib/format'
import { useFamilyData } from '../hooks/useFamilyData'
import Checkin from './Checkin'

interface Props {
  onRecordChange: () => void
  photosEnabled: boolean
}

export default function CheckinPage({ onRecordChange, photosEnabled }: Props) {
  const { records } = useFamilyData()

  const { todayTotal, todayByType } = useMemo(() => {
    let pee = 0
    let poop = 0
    let mixed = 0
    for (const r of records) {
      if (!isToday(r.occurred_at)) continue
      if (r.type === 'pee') pee++
      else if (r.type === 'poop') poop++
      else if (r.type === 'mixed') mixed++
    }
    return { todayTotal: pee + poop + mixed, todayByType: { pee, poop, mixed } }
  }, [records])

  return (
    <main>
      <section className="checkin-today">
        <div className="checkin-today-left">
          <div className="checkin-today-label">今日</div>
          <div className="checkin-today-value">{todayTotal}</div>
        </div>
        <div className="checkin-today-breakdown">
          <span className="bd-item bd-pee">
            <span className="bd-dot" />嘘嘘 {todayByType.pee}
          </span>
          <span className="bd-item bd-poop">
            <span className="bd-dot" />臭臭 {todayByType.poop}
          </span>
          {todayByType.mixed > 0 && (
            <span className="bd-item bd-mixed">
              <span className="bd-dot" />混合 {todayByType.mixed}
            </span>
          )}
        </div>
      </section>

      <Checkin onSuccess={onRecordChange} photosEnabled={photosEnabled} />
    </main>
  )
}
